import { useI18n } from '@cascade/react/i18n';
import { ProjectPicker } from '#components/project-picker/index.ts';
import { Layout } from '#layout/index.ts';

export const SelectProject = () => {
  const { translate } = useI18n();

  return (
    <Layout mode='card' title={translate('projects.select.title')}>
      <ProjectPicker />
    </Layout>
  );
};
